import React from 'react';

import { View, Text, Pressable, StyleSheet } from 'react-native';

import { OPPureComponent, FlagIcon } from '../components';

import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../constants/styles';

export default class LanguageSelect extends OPPureComponent {
  unSelectedLocales() {
    const { locales, selectedLocale } = this.props;

    if (!locales) return [];

    return Object.keys(locales)
      .map((key) => {
        if (key === selectedLocale) return null;
        return { label: locales[key], id: key };
      })
      .filter((i) => i !== null);
  }

  renderLocaleButton = (item) => {
    return (
      <Pressable
        key={`${item.id}`}
        style={styles.button}
        onPress={() => {
          this.props.onSetLocale(item.id);
        }}
      >
        <FlagIcon languageTag={item.id} />
        <Text style={styles.text}>{item.label}</Text>
      </Pressable>
    );
  };

  render() {
    const locales = this.unSelectedLocales();

    return <View style={styles.container}>{locales.map(this.renderLocaleButton)}</View>;
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  button: {
    flex: 1,
    height: 70,
    paddingBottom: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    ...FONT.medium,
    color: __WEB__ ? COLOR.callToAction : COLOR.contrast,
    fontSize: 16,
    marginLeft: 10,
  },
});
